// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__MnQdM","Desktop":"Navbar_Desktop__p02EQ","Mobile":"Navbar_Mobile__j6BMa"};